<template>
    <v-form
        data-vv-scope="nameForm"
        v-model="valid"
    >
        <v-container
            grid-list-md
            pt-0
        >
            <v-layout wrap>
                <v-flex
                    md12
                    sm12
                    xs12
                >
                    <v-text-field
                        :error-messages="nameErrors"
                        @blur="$v.newPersonName.$touch()"
                        @input="$v.newPersonName.$touch()"
                        label="Name"
                        v-model="newPersonName"
                    />
                </v-flex>
                <v-flex>
                    <v-menu
                        :close-on-content-click="false"
                        :nudge-right="40"
                        min-width="290px"
                        offset-y
                        ref="dateOfBirthMenu"
                        transition="scale-transition"
                        v-model="dateOfBirthMenu"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                :error-messages="newPersonDateOfBirthErrors"
                                @blur="$v.newPersonDateOfBirth.$touch()"
                                @input="menu2 = false && $v.newPersonDateOfBirth.$touch()"
                                label="Date of birth"
                                prepend-icon="event"
                                readonly

                                slot="activator"
                                v-model="newPersonDateOfBirth"
                                v-on="on"
                            />
                        </template>
                        <v-date-picker
                            :error-messages="newPersonDateOfBirthErrors"
                            :max="sixteenYearsAgo"
                            @blur="$v.newPersonDateOfBirth.$touch()"
                            @input="dateOfBirthMenu = false && $v.newPersonDateOfBirth.$touch()"
                            min="1940-01-01"
                            no-title
                            ref="picker"
                            scrollable
                            v-model="newPersonDateOfBirth"
                        />
                    </v-menu>
                </v-flex>
                <v-flex
                    md12
                    sm12
                    xs12
                >
                    <v-text-field
                        :error-messages="newPersonEmailAddressWorkErrors"
                        @blur="$v.newPersonEmailAddressWork.$touch()"
                        @input="$v.newPersonEmailAddressWork.$touch()"
                        label="Email Address (Work)"
                        v-model="newPersonEmailAddressWork"
                    />
                </v-flex>
                <v-flex
                    md12
                    sm12
                    xs12
                >
                    <v-text-field
                        :error-messages="newPersonEmailAddressPersonalErrors"
                        @blur="$v.newPersonEmailAddressPersonal.$touch()"
                        @input="$v.newPersonEmailAddressPersonal.$touch()"
                        label="Email Address (Personal)"
                        v-model="newPersonEmailAddressPersonal"
                    />
                </v-flex>
                <v-flex
                    md12
                    sm12
                    xs12
                >
                    <v-select
                        :error-messages="newPersonManagerIdErrors"
                        :items="livePersonnel()"
                        @blur="$v.newPersonManagerId.$touch()"
                        @input="$v.newPersonManagerId.$touch()"
                        height="46"
                        item-text="name"

                        item-value="personId"
                        label="Manager"
                        v-model="newPersonManagerId"
                    />
                </v-flex>
                <v-flex
                    md12
                    sm12
                    xs12
                >
                    <v-select
                        :error-messages="newPersonTeamIdErrors"
                        :items="teamList"
                        @blur="$v.newPersonTeamId.$touch()"
                        @input="$v.newPersonTeamId.$touch()"
                        height="46"
                        item-text="name"

                        item-value="teamId"
                        label="Team"
                        v-model="newPersonTeamId"
                    />
                </v-flex>
            </v-layout>
        </v-container>
        <!--    <v-btn @click="validate">Submit</v-btn>-->
        <!--    <v-btn @click="changeStep(+1)">Next</v-btn>-->
        <!--    <v-btn @click="validate()">Validate</v-btn>-->
        <!--                <v-btn @click="redirect">redirect</v-btn>-->
    </v-form>
</template>

<script>
    import {mapGetters} from "vuex";
    import {email, maxLength, required} from 'vuelidate/lib/validators'
    import {SET_NEW_PERSON_FORM_SECTION_STATE, UPDATE_NEW_PERSON} from "@/store/person/mutations";
    import {FETCH_TEAM_LIST} from "@/store/team/actions";
    import {FETCH_PERSONNEL} from "@/store/person/actions";
    import {validationMixin} from 'vuelidate'

    export default {
        name: "Name",

        mixins: [validationMixin],

        validations: {
            newPersonName: {required, maxLength: maxLength(100)},
            newPersonDateOfBirth: {required},
            newPersonEmailAddressWork: {email},
            newPersonEmailAddressPersonal: {required, email},
            newPersonManagerId: {required},
            newPersonTeamId: {required},
        },

        data: function () {
            return {
                valid: false,
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+/.test(v) || 'E-mail must be valid'
                ],
                dateOfBirthMenu: false,
                sixteenYearsAgo: moment().subtract(16, 'years').format('YYYY-MM-DD'),
            }
        },


        computed: {
            ...mapGetters(
            [
                "livePersonnel",
                "teamList",
            ]
            ),

            nameErrors() {
                const errors = [];
                if (!this.$v.newPersonName.$dirty) return errors;
                !this.$v.newPersonName.maxLength && errors.push('Name must be at most 100 characters long');
                !this.$v.newPersonName.required && errors.push('Name is required.');
                return errors
            },

            newPersonDateOfBirthErrors() {
                const errors = [];
                if (!this.$v.newPersonDateOfBirth.$dirty) return errors;
                !this.$v.newPersonDateOfBirth.required && errors.push('required.');
                return errors
            },

            newPersonEmailAddressWorkErrors() {
                const errors = [];
                if (!this.$v.newPersonEmailAddressWork.$dirty) return errors;
                !this.$v.newPersonEmailAddressWork.email && errors.push('Must be valid email address.');
                return errors
            },

            newPersonEmailAddressPersonalErrors() {
                const errors = [];
                if (!this.$v.newPersonEmailAddressPersonal.$dirty) return errors;
                !this.$v.newPersonEmailAddressPersonal.required && errors.push('Email Address is required.');
                !this.$v.newPersonEmailAddressPersonal.email && errors.push('Must be valid email address.');
                return errors
            },

            newPersonName: {
                get() {
                    return this.$store.state.person.newPerson.name;
                },
                set(value) {
                    let data = {};
                    data.key = 'name';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonDateOfBirth: {
                get() {
                    return this.$store.state.person.newPerson.dateOfBirth;
                },
                set(value) {
                    let data = {};
                    data.key = 'dateOfBirth';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmailAddressWork: {
                get() {
                    return this.$store.state.person.newPerson.emailAddressWork;
                },
                set(value) {
                    let data = {};
                    data.key = 'emailAddressWork';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmailAddressPersonal: {
                get() {
                    return this.$store.state.person.newPerson.addresses[0].emailAddressPersonal;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'addresses';
                    data.key = 'emailAddressPersonal';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonManagerId: {
                get() {
                    return this.$store.state.person.newPerson.managerId;
                },
                set(value) {
                    let data = {};
                    data.key = 'managerId';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonManagerIdErrors() {
                const errors = [];
                if (!this.$v.newPersonManagerId.$dirty) return errors;
                !this.$v.newPersonManagerId.required && errors.push('Manager is required.');
                return errors
            },

            newPersonTeamId: {
                get() {
                    return this.$store.state.person.newPerson.teams[0].teamId;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'teams';
                    data.key = 'teamId';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonTeamIdErrors() {
                const errors = [];
                if (!this.$v.newPersonTeamId.$dirty) return errors;
                !this.$v.newPersonTeamId.required && errors.push('Team is required.');
                return errors
            },
        },

        watch: {
            dateOfBirthMenu(val) {
                val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
            },
        },

        mounted() {
            this.fetchTeamList();
            this.fetchPersonnelList();
        },

        methods: {
            fetchPersonnelList() {
                this.$store.dispatch(FETCH_PERSONNEL);
            },
            fetchTeamList() {
                this.$store.dispatch(FETCH_TEAM_LIST);
            },

            validate() {
                this.$v.$touch();

                let formState = false;

                if (this.$v.$anyDirty === false) {
                    formState = 'clean';
                } else {
                    if (this.$v.$anyError === true) {
                        formState = 'error';
                    } else {
                        formState = 'complete';
                    }
                }
                this.$store.commit(SET_NEW_PERSON_FORM_SECTION_STATE, {section: 'name', state: formState});
            },
        },

    }
</script>

<style scoped>

</style>
